import { http } from '.';

/**
 * 카드 관련 API
 */
export const getCreditCardList = async () => {
  const response: any = await http.get(`/orders/credit-cards`);
  return response?.data || [];
};

export const getPaymentMethodReserve = async () => {
  const response = await http.get(`/orders/credit-cards/stripe/payment-methods/reserve`);
  return response;
};

export const deleteCard = async (creditCardId: any) => {
  const response = await http.del(`/orders/credit-cards/${creditCardId}`);
  return response;
};

export const postPaymentMethodConfirm = async (payload: any) => {
  const response = await http.post(`/orders/credit-cards/stripe/payment-methods/confirm`, payload);
  return response;
};

/**
 * 주문 관련 API
 */
export const postOrder = async (payload: any) => {
  const response = await http.post(`/orders/create`, payload);
  return response;
};

export const cancelOrder = async (payload: any) => {
  const response = await http.post(`/orders/cancel`, payload);
  return response;
};

export const checkOrder = async (orderTxId: string) => {
  const response = await http.get(`/orders/check/${orderTxId}`);
  return response;
};
